<script>
  import { link } from "svelte-routing";
  import { useAnalytics } from "./analytics";

  let windowScrollY = 0;

  function handleScroll(e) {
    windowScrollY = window.scrollY;
  }
</script>

<style>
  nav .container {
    padding-bottom: 6px;
    padding-top: 6px;
    border-bottom: 1px solid #fff;
  }

  nav.is-attached .container {
    transition-property: border-bottom, box-shadow;
    transition-duration: 0.5s;
    transition-timing-function: linear;
    border-bottom-color: #eaeaea;
    box-shadow: #0000000d 0 10px 8px -8px;
  }

  a.navbar-item {
    color: #333;
  }

  a.navbar-item:visited {
    color: #333;
  }

  a.navbar-item:hover {
    background-color: initial;
  }

  .logo {
    font-family: montserrat;
    text-transform: uppercase;
    font-weight: 300;
    letter-spacing: -2px;
    color: #333;
    font-size: 24px;
  }

  a.logo:hover {
    text-decoration: none;
  }


  @media screen and (max-width: 899.5px) {
    .logo {
      padding-left: 20px;
    }
  }

</style>

<svelte:window on:scroll={handleScroll}/>

<nav class="navbar is-fixed-top" class:is-attached={windowScrollY !== 0} role="navigation" aria-label="main navigation">
  <div class="container">
    <div class="navbar-brand">
      <a class="navbar-item logo" href="/" use:link>
        Bringflow
      </a>
    </div>

    <div class="navbar-menu">
      <div class="navbar-end">
        <a href="https://app.bringflow.com/login" class="navbar-item" data-action="SignIn" data-label="Navigation" on:click={useAnalytics}>Log in</a>
        <div class="navbar-item">
          <a href="https://app.bringflow.com/register" class="button is-primary" data-action="SignUp" data-label="Navigation" on:click={useAnalytics}>Sign up for free</a>
        </div>
      </div>
    </div>
  </div>
</nav>
